/* eslint-disable max-len */
import React, { useState } from 'react';
import { Colors } from '../../ui';
import { Popover } from '../canvas/ui/Popover';
import { Avatar } from './Avatar';
import { AvatarList } from './AvatarList';

export type AvatarStripItem = {
    id: string,
    name: string,
    photo?: string,
    color?: string,
};

export type AvatarStripProps<T extends AvatarStripItem> = {
    items: T[],
    selected?: T[],
    onSelect?: (next: T[]) => void,
};

export const AvatarStrip = <T extends AvatarStripItem>({ items, selected, onSelect }: AvatarStripProps<T>) => {

    const selectedIds = new Set(selected?.map(x => x.id) ?? []);

    const visible = items.slice(0, 9);
    const hidden = items.slice(9);
    const more = items.length - visible.length;
    const [moreOpen, setMoreOpen] = useState(false);

    const onToggle = (user: T) => {
        onSelect?.(selectedIds.has(user.id) ? selected.filter(x => x.id !== user.id) : [...selected, user]);
    };

    return <Avatar.Group>
        {visible.map(x =>
            <Avatar
                key={x.id}
                name={x.name}
                photo={x.photo}
                color={x.color}
                clickable={!!onSelect}
                selected={selectedIds.has(x.id)}
                onClick={() => onToggle(x)}
            />)}
        {more > 0 &&
            <Popover
                content={<AvatarList items={hidden} selected={selected} onSelect={onSelect} />}
                inner={{ direction: 'down', offset: '0.5' }}
                placement="bottom-end"
                open={moreOpen}
                onOpenChange={setMoreOpen}
            >
                <Avatar name="More" color={Colors.primary} clickable selected={moreOpen}>
                    <span style={{ fontSize: '0.875rem' }}>+{more}</span>
                </Avatar>
            </Popover>
        }
    </Avatar.Group>;
};
